import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fa5b0410&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fa5b0410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5b0410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa5b0410')) {
      api.createRecord('fa5b0410', component.options)
    } else {
      api.reload('fa5b0410', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fa5b0410&scoped=true&", function () {
      api.rerender('fa5b0410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/crash/components/crash-game/index.vue"
export default component.exports